import { User } from "@/types/auth";
import { ACCOUNT_SETTINGS_ROUTES } from "@/utils/constants/accountSettingsRoutes";
import {
  IconBrandSafari,
  IconHeart,
  IconSmartHome,
  IconUserCircle,
} from "@tabler/icons-react";

export type BottomNavItem = {
  label: "Home" | "Discover" | "Login" | "Favorite" | "Profile";
  href: string;
  Icon: typeof IconSmartHome;
  match?: (pathname: string) => boolean;
  isLoginTrigger?: boolean;
};

const sharedItems: BottomNavItem[] = [
  {
    label: "Home",
    href: "/",
    Icon: IconSmartHome,
    match: (pathname: string) => pathname === "/",
  },
  {
    label: "Discover",
    href: "/discover",
    Icon: IconBrandSafari,
    match: (pathname: string) => pathname.startsWith("/discover"),
  },
];

const guestItems: BottomNavItem[] = [
  ...sharedItems,
  {
    label: "Login",
    href: "/",
    Icon: IconUserCircle,
    isLoginTrigger: true,
  },
];

const authenticatedItems: BottomNavItem[] = [
  ...sharedItems,
  {
    label: "Favorite",
    href: "/favorites",
    Icon: IconHeart,
    match: (pathname: string) => pathname.startsWith("/favorites"),
  },
  {
    label: "Profile",
    href: ACCOUNT_SETTINGS_ROUTES.root,
    Icon: IconUserCircle,
    match: (pathname: string) =>
      pathname.startsWith(ACCOUNT_SETTINGS_ROUTES.root),
  },
];

export const getBottomNavbarItems = (user: User | null): BottomNavItem[] =>
  user ? authenticatedItems : guestItems;
